import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  service = null,
  selectedServices = [],
  isLoading = false 
}) => {
  if (!isOpen) return null;

  const isBulkDelete = selectedServices?.length > 1;
  const serviceName = service?.name || '';
  const selectedCount = selectedServices?.length;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fa-IR')?.format(price) + ' ریال';
  };

  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    
    if (hours > 0 && mins > 0) {
      return `${hours} ساعت و ${mins} دقیقه`;
    } else if (hours > 0) {
      return `${hours} ساعت`;
    } else {
      return `${mins} دقیقه`;
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
      <div className="bg-card rounded-lg border border-border w-full max-w-md animate-scale-in">
        {/* Header */}
        <div className="flex items-center gap-3 p-6 border-b border-border">
          <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} className="text-error" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">
              {isBulkDelete ? 'حذف چندین خدمت' : 'حذف خدمت'}
            </h2>
            <p className="text-sm text-muted-foreground">
              این عمل قابل بازگشت نیست
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {isBulkDelete ? (
            <div className="space-y-4">
              <p className="text-foreground">
                آیا مطمئن هستید که می‌خواهید <span className="font-medium text-error">{selectedCount} خدمت</span> انتخاب شده را حذف کنید؟
              </p>
              
              <div className="bg-muted/30 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Info" size={16} className="text-primary" />
                  <span className="text-sm font-medium text-foreground">تأثیرات حذف:</span>
                </div>
                <ul className="text-sm text-muted-foreground space-y-1 mr-6">
                  <li>• تمام نوبت‌های مرتبط با این خدمات لغو خواهد شد</li>
                  <li>• تخصیص کارکنان به این خدمات حذف می‌شود</li>
                  <li>• سابقه ارائه این خدمات حفظ خواهد شد</li>
                </ul>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-foreground">
                آیا مطمئن هستید که می‌خواهید خدمت <span className="font-medium text-error">"{serviceName}"</span> را حذف کنید؟
              </p>

              {service && (
                <div className="bg-muted/30 rounded-lg p-4">
                  <h4 className="text-sm font-medium text-foreground mb-3">جزئیات خدمت:</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">مدت زمان:</span>
                      <span className="text-foreground">{formatDuration(service?.duration)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">قیمت:</span>
                      <span className="text-foreground">{formatPrice(service?.price)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">کارکنان تخصیص یافته:</span>
                      <span className="text-foreground">
                        {service?.assignedEmployees?.length || 0} نفر
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="AlertTriangle" size={16} className="text-warning" />
                  <span className="text-sm font-medium text-foreground">هشدار:</span>
                </div>
                <ul className="text-sm text-muted-foreground space-y-1 mr-6">
                  <li>• تمام نوبت‌های آینده این خدمت لغو خواهد شد</li>
                  <li>• تخصیص کارکنان به این خدمت حذف می‌شود</li>
                  <li>• سابقه ارائه این خدمت حفظ خواهد شد</li>
                </ul>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-border bg-muted/30">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            انصراف
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            loading={isLoading}
            iconName="Trash2"
            iconPosition="left"
          >
            {isBulkDelete ? `حذف ${selectedCount} خدمت` : 'حذف خدمت'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;